exports = module.exports = require("../../../../build/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ui-scroll-view{position:relative}.ui-scroll-view .ui-scroll-view-inner .scroll-view-footer{padding:16px 0;text-align:center;font-size:14px;color:#ccc}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/sass-loader/dist/cjs.js!../src/ui/scroll-view/scss/index.scss
// module id = 685
// module chunks = 0 1 2 3